// extracted by mini-css-extract-plugin
export var tags = "styles-module--tags--28txu";
export var title = "styles-module--title--3Txib";
export var list = "styles-module--list--12Qto";
export var guideItem = "styles-module--guideItem--vdts9";